import storeAxios from "@/store/axios";
import Vue from "vue";

export default {
	namespaced: true,
	state() {
		return {
			authProcess: null,
			storeAxiosLangInterceptor: null,
			user: null,
			lang: Vue.$t.currentLang,
			countries: null,
		};
	},

	mutations: {
		setAuthProcess(state, { val }) {
			state.authProcess = val;
		},
		setUser(state, { val }) {
			state.user = val;
		},

		setStoreAxiosLangInterceptor(state, { val }) {
			state.storeAxiosLangInterceptor = val;
		},

		updateUser(state, { val }) {
			state.user = val;
		},

		setCountries(state, { val }) {
			state.countries = val;
		},

		setLang(state, { val }) {
			state.lang = val;
		},
	},

	actions: {
		initAuth({ commit, dispatch }) {
			let authProcess = storeAxios
				.get(`Users/whoami`)
				.then(({ data: user }) => {
					commit("setUser", { val: user });
					dispatch("setLang", user.lang);
					return user;
				})
				.catch(() => {});

			commit("setAuthProcess", { val: authProcess });
		},

		login({ commit, dispatch }, { email, password }) {
			return storeAxios
				.post("Users/login", {
					email,
					password,
				})
				.then((res) => {
					const user = res.data;

					commit("setUser", { val: user });
					dispatch("setLang", user.lang);

					return res;
				})
				.catch((err) => {
					console.error(err);
					throw err;
				});
		},

		logout({ commit }) {
			return storeAxios
				.post("Users/logout")
				.then(() => {
					storeAxios.defaults.headers.common["Authorization"] = null;
					commit("setUser", { val: null });
				})
				.catch((err) => {
					console.error(err);
					throw err;
				});
		},

		createAccount(
			{ state, commit, dispatch },
			{ userName, firstName, lastName, email, password, company }
		) {
			return storeAxios
				.post(
					"Users",
					{
						userName,
						email,
						password,
						firstName,
						lastName,
						company,
					}
					// { params: { register_lang: state.currentLang } }
				)
				.catch((err) => {
					console.error(err);
					throw err;
				});
		},

		// updateAccount({ state, commit, dispatch }, val) {
		// 	commit("updateUser", {
		// 		val: {
		// 			...state.user,
		// 			...val,
		// 		},
		// 	});

		// 	dispatch("setLang", val.lang);
		// },

		setLang({ commit, state }, val) {
			if (val) {
				storeAxios.interceptors.request.eject(state.storeAxioslangInterceptor);
				const langInterceptor = storeAxios.interceptors.request.use(
					(config) => {
						config.params = config.params || {};
						config.params["lang"] = val;
						return config;
					}
				);

				commit("setStoreAxiosLangInterceptor", {
					val: langInterceptor,
				});

				commit("setLang", { val });

				Vue.$t.setLang(val);
			}
		},

		requestPasswordReset({ state }, { email }) {
			return storeAxios
				.post("Users/forgot-password", {
					email,
				})
				.catch((err) => {
					console.error(err);
					throw err;
				});
			//{commit}, { email }) {
			//
		},

		resetPassword({ state }, { confirmPassword, password, userId, code }) {
			return storeAxios
				.post("Users/reset-password", {
					userId,
					confirmPassword,
					password,
					code,
				})
				.catch((err) => {
					console.error(err);
					throw err;
				});
			//{commit}, { email }) {
			//
		},
	},

	getters: {
		loggedInUser(state) {
			return state.user;
		},
	},
};
